import { LinearProgress } from "@mui/material";
import { FeatureFlag } from "./featureFlags";
import { useFeatureFlags } from "./FeatureFlagsProvider";
import NotLicensed from "./NotLicensed";

interface RestrictedFeatureRealmProps {
  /** Features the tenant must have licensed. All of them must be enabled. */
  requiredFeatures: [FeatureFlag, ...FeatureFlag[]];
  /** Render nothing instead of the not-licensed page. Used for navigation entries and tiles. */
  silent?: boolean;
  children: React.ReactNode;
}

/**
 * Feature-flag counterpart to RestrictedTenantRealm.
 *
 * While the set is still resolving nothing flagged is rendered, so an unlicensed entry point is
 * never briefly visible. `silent` is what keeps unlicensed capabilities absent from navigation
 * rather than shown locked.
 */
export default function RestrictedFeatureRealm({
  requiredFeatures,
  silent = false,
  children
}: RestrictedFeatureRealmProps) {
  const { loading, isEnabled } = useFeatureFlags();

  if (loading) {
    return silent ? null : <LinearProgress />;
  }

  const missing = requiredFeatures.find(feature => !isEnabled(feature));

  if (!missing) {
    return <>{children}</>;
  }

  return silent ? null : <NotLicensed feature={missing} />;
}
